import React, { useRef } from "react";

import PageBanner from "../../layouts/PageBanner";

import president from "../../assets/images/TheSigningOfficers/sats_president.jpg";
import ApiServer from "../../helpers/Api_help";

const Announcement = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="PRESIDENT’S MESSAGE" />
        <section className="content-inner-2 section-wrapper5">
          <div className="container text-dark">
            <div className="row align-items-center">
              <div
                className="col-lg-12 d-flex flex-wrap justify-content-between align-items-center
              "
              >
                <div className="section-head col-lg-6 col-md-6 col-sm-12">
                  <h3>
                    வணக்கம்!
                    <br />
                  </h3>

                  <p className="m-t20 text-justify">
                    I am deeply honoured and privileged to serve as  <span style={{ fontWeight: 600, color: "#000" }}>President of
                    San Antonio Tamil Sangam (SATS) </span>for the 2026-2027 term, an
                    organization built upon the values of inclusiveness, unity,
                    and cultural pride. I sincerely thank every member,
                    volunteer, past leader, and well-wisher who has placed their
                    trust in me and in our team.
                    <br /> <br />
                    To me,  <span style={{ fontWeight: 600, color: "#000" }}>“Namma SATS”</span> is not simply an organization, it is a
                    home away from home, a family woven together by our shared
                    love for Tamil language, culture, traditions, and community
                    values. It is a place where friendships become family, where
                    our children discover their roots, and where generations
                    unite to celebrate the pride and beauty of Tamil heritage.
                    <br /> <br />
                    “கருமம் செயஒருவன் கைதூவேன் என்னும் <br />
                    பெருமையின் பீடுடையது இல்” - Thirukkural
                    <br />
                    <br />
                    The essence reminds us that relationships and unity are
                    stronger than momentary differences. When people come
                    together with understanding and shared purpose, communities
                    flourish and endure.
                    <br /> <br />
                    As we begin this new chapter, our vision is clear to make
                    “Namma SATS” a stronger, more connected, and more vibrant
                    community. We aspire to create meaningful cultural
                    celebrations, strengthen Tamil education, encourage youth
                    leadership, expand community outreach, and build
                    opportunities where every member feels valued and inspired
                    to contribute.
                    <br /> <br />
                    No President succeeds alone. The true strength of SATS has
                    always been its people, our volunteers, families, sponsors,
                    past leaders, and every member who gives their time and
                    heart to this community. Together, with one vision and one
                    purpose, let us continue building memories, preserving
                    traditions, and creating a legacy for future generations.
                    <br /> <br />
                    Let us grow together. Let us celebrate together. Let us lead
                    together.
                    <br />
                    <br />
                    With warm regards,  <br />
                    <span style={{ fontWeight: 600, color: "#000" }}>
                      Dr. Yuvaraj Munian
                    </span>
                     <br/>
                     <span style={{ fontWeight: 600, color: "#000" }}>President</span><br />
                     <span style={{ fontWeight: 600, color: "#000" }}>San Antonio Tamil Sangam (2026–2027)</span>
                  </p>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 ">
                  {/* <img src={president} alt="president" /> */}
                  <img
                    src={`${ApiServer}assets/committee/sats_president.jpg`}
                    alt="president"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Announcement;
